<template>
  <div class="ag-page_assets position-relative">
    <ag-loading v-if="loading" />
    <div class="ag-content ag-card" v-else>
      <div
        class="ag-card_header d-flex align-items-center justify-content-between"
      >
        <div v-if="navigation" class="ag-card_navigation">
          <ul class="nav">
            <li
              v-for="(item, key) in navigation"
              class="nav-item d-flex align-items-center active"
              :key="key"
            >
              <router-link
                class="
                  nav-item
                  pt-3
                  pb-3
                  pl-4
                  pr-4
                  d-block d-flex
                  align-items-center
                "
                :class="
                  $route.params.param === item.url || item.active
                    ? 'active'
                    : ''
                "
                :to="'/' + $route.path.split('/')[1] + '/' + item.url"
                :key="key"
              >
                <i
                  :class="`ag-icon ag-icon_${item.icon} mr-1`"
                  v-if="item.icon"
                ></i>
                {{ $t(item.title) }}
              </router-link>
              <slot :name="item.navFilter"></slot>
            </li>
          </ul>
        </div>
      </div>
      <div class="ag-card_body">
        <div
          class="
            d-flex
            align-items-center
            justify-content-between
            pt-3
            pr-3
            pb-3
            pl-5px
            ag-table_filter
          "
        >
          <div class="ag-card_breadcrumb p-4">
            <div class="d-flex align-items-center mr-2">
              <a
                href="/assets"
                class="d-flex align-items-center"
                v-role="[Roles.AGMSAdmin, Roles.PartnerAdmin]"
              >
                <i class="ag-icon ag-icon_breadcrumb mr-2"></i> {{$t("companies")}}</a
              >
              <span
                style="font-size: 13px"
                class="d-flex align-items-center"
                v-role="[
                  Roles.GroupAdmin,
                  Roles.GroupAudit,
                  Roles.CompanyAdmin,
                  Roles.SiteAdmin,
                  Roles.SiteAudit,
                ]"
              >
                <i class="ag-icon ag-icon_breadcrumb mr-2"></i> {{$t("companies")}}
              </span>
            </div>

            <div class="d-flex align-items-center mr-2" v-if="company">
              <span
                class="ag-icon ag-icon_rightArrow"
                style="width: 0.8rem; height: 1rem; margin-right: 1rem"
              ></span>
              <a
                :href="`/endpoints/company/${company.companyGuid}/sites`"
                class="d-flex align-items-center"
                v-role="[Roles.AGMSAdmin, Roles.PartnerAdmin]"
              >
                <i class="ag-icon ag-icon_breadcrumb mr-2"></i>
                {{ company.companyName }}</a
              >
              <router-link
                :to="`/endpoints/company/${company.companyGuid}/sites`"
                class="d-flex align-items-center"
                v-role="[
                  Roles.CompanyAdmin,
                ]"
              >
                <i class="ag-icon ag-icon_breadcrumb mr-2"></i>
                {{ company.companyName }}</router-link
              >
              <span
                class="d-flex align-items-center"
                style="font-size: 13px"
                v-role="[
                  Roles.GroupAdmin,
                  Roles.GroupAudit,
                  Roles.SiteAdmin,
                  Roles.SiteAudit,
                ]"
              >
                <i class="ag-icon ag-icon_breadcrumb mr-2"></i>
                {{ company.companyName }}
              </span>
            </div>

            <div class="d-flex align-items-center mr-2">
              <span
                class="ag-icon ag-icon_rightArrow"
                style="width: 0.8rem; height: 1rem; margin-right: 1rem"
              ></span>
              <a
                :href="`/endpoints/company/${company.companyGuid}/sites/${site.siteGuid}/groups`"
                class="d-flex align-items-center"
                v-role="[Roles.AGMSAdmin, Roles.PartnerAdmin, Roles.CompanyAdmin]"
              >
                <i class="ag-icon ag-icon_surfaces mr-2"></i>
                {{ site.name }}</a
              >
              <span
                style="font-size: 13px"
                class="d-flex align-items-center"
                v-role="[
                  Roles.GroupAdmin,
                  Roles.GroupAudit,
                  Roles.SiteAdmin,
                  Roles.SiteAudit,
                ]"
              >
                <i class="ag-icon ag-icon_surfaces mr-2"></i>
                {{ site.name }}
              </span>
            </div>
            <div class="d-flex align-items-center mr-2">
              <span
                class="ag-icon ag-icon_rightArrow"
                style="width: 0.8rem; height: 1rem; margin-right: 1rem"
              ></span>
              <a
                :href="`/endpoints/company/${company.companyGuid}/sites/${site.siteGuid}/groups/${params.groupGuid}/computers`"
                class="d-flex align-items-center"
              >
                <i class="ag-icon ag-icon_group mr-2"></i>
                {{ group.name }}
              </a>
            </div>
            <div class="d-flex align-items-center mr-2">
              <span
                class="ag-icon ag-icon_rightArrow"
                style="width: 0.8rem; height: 1rem; margin-right: 1rem"
              ></span>
              <i class="ag-icon ag-icon_assets mr-2"></i>
              {{ selectedComp.WindowsComputerName }}
            </div>
          </div>
        </div>
        <div class="row ag-computer p-4">
          <div class="col-md-6">
            <div class="d-flex justify-content-between mb-4">
              <div class="w-50">
                <h5>
                  <ag-truncate
                    :text="selectedComp.WindowsComputerName"
                    :options="{ position: 'middle', first: 8, last: 8 }"
                  ></ag-truncate>
                </h5>
                <h6>Endpoint Host Name</h6>
              </div>
              <div class="w-50">
                <div class="w-50">
                  <h5>
                    <ag-truncate
                      :text="selectedComp.MachineDomainWorkgroup"
                      :options="{ position: 'middle', first: 13, last: 13 }"
                    ></ag-truncate>
                  </h5>
                  <h6>{{ $t("domain") }}</h6>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-between mb-4">
              <div class="w-50">
                <h5>
                  {{
                    selectedComp.companySiteGroupInfo
                      ? selectedComp.companySiteGroupInfo.siteName
                      : ""
                  }}
                </h5>
                <h6>{{ $t("sitename") }}</h6>
              </div>
              <div class="w-50">
                <h5>
                  <ag-truncate
                    :text="selectedComp.companySiteGroupInfo.groupName"
                    v-if="selectedComp.companySiteGroupInfo"
                    :options="{ position: 'middle', first: 13, last: 13 }"
                  ></ag-truncate>
                </h5>
                <h6>{{ $t("groupname") }}</h6>
              </div>
            </div>
            <div class="d-flex justify-content-between mb-4">
              <div class="w-50">
                <h5>{{ selectedComp.PolicyFileVersion }}</h5>
                <h6>{{$t("policyversion")}}</h6>
              </div>
              <div class="w-50">
                <h5>
                  {{ selectedComp.eventCount }}
                </h5>
                <h6>{{$t("eventcount")}}</h6>
              </div>
            </div>

            <div class="d-flex justify-content-between mb-4">
              <div class="w-50">
                <h5>{{ selectedComp.LastIPv4 }}</h5>
                <h6>{{$t("lastIpV4")}}</h6>
              </div>
              <div class="w-50">
                <h5>
                  <ag-truncate
                    :text="selectedComp.LastIPv6"
                    :options="{ position: 'middle', first: 15, last: 15 }"
                  ></ag-truncate>
                </h5>
                <h6>{{"lastIpV6"}}</h6>
              </div>
            </div>

            <div class="d-flex justify-content-between mb-4">
              <div class="w-50">
                <h5>{{ selectedComp.AgentVersion }}</h5>
                <h6>{{$t("agentversion")}}</h6>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row graphs">
              <div class="col-md-6">
                <ag-charts
                  style="height: 350px"
                  :options="maliciousHashes"
                ></ag-charts>
              </div>
              <div class="col-md-6">
                <ag-charts
                  style="height: 350px"
                  :options="severityDistribution"
                ></ag-charts>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import AgCharts from "@/components/ag-charts";
import { useStore } from "@/store";
import api from "@/api/index";
import { Roles } from "@/helpers/enums/Roles";
import AgLoading from "@/components/ag-loading/index.vue";
import Swal from "sweetalert2";
import AgTruncate from "@/components/ag-truncate/index.vue";

const store = useStore();
export default {
  name: "ag-computer",
  data() {
    return {
      company: "",
      site: "",
      group: "",
      Roles: Roles,
      selectedComp: {},
      loading: true,
      users: [],
      maliciousHashes: {
        tooltip: {
          trigger: "item",
        },
        legend: {
          bottom: "0",
          left: "center",
          textStyle: {
            fontSize: "11",
          },
        },
        series: [
          {
            name: "Numbers of found hashes",
            type: "pie",
            radius: ["54%", "60%"],
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            avoidLabelOverlap: true,
            label: {
              show: true,
              position: "center",
              backgroundColor: "#f8f8f8",
              padding: 10,
            },
            data: [],
          },
        ],
        color: ["#D15656", "#F2AE11", "#61A667"],
      },
      severityDistribution: {
        tooltip: {
          trigger: "item",
        },
        legend: {
          bottom: "0",
          left: "center",
          textStyle: {
            fontSize: "11",
          },
        },
        series: [
          {
            name: "Severity Distribution",
            type: "pie",
            radius: ["54%", "60%"],
            avoidLabelOverlap: true,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: true,
              position: "center",
              backgroundColor: "#f8f8f8",
              padding: 10,
            },
            data: [],
          },
        ],
        color: ["#D15656", "#F2AE11", "#61A667"],
      },
      navigation: [
        {
          title: "endpoints",
          icon: "drak_computer",
          url: "computers/all",
        },
        {
          title: "browseassets",
          active: true,
          icon: "breadcrumb",
          url: "",
        },
      ],
    };
  },
  computed: {
    params() {
      return this.$route.params;
    },
  },
  components: { AgCharts, AgLoading, AgTruncate },
  async created() {
    await this.getCompanyInfo();
    await this.getSiteInfo();
    await this.getGroupInfo();
    await this.getList();
  },
  methods: {
    async getCompanyInfo() {
      const guid = this.$route.params.companyId;
      if (guid) {
        const res = await api.companies.getByGuid(guid);
        this.company = res.data.entityData;
      }
    },
    async getSiteInfo() {
      const guid = this.$route.params.siteGuid;
      const res = await api.sites.getById(guid);
      this.site = res.data.entityData;
    },
    async getGroupInfo() {
      const guid = this.$route.params.groupGuid;
      const res = await api.groups.getById(guid);
      this.group = res.data.entityData;
    },
    async getList() {
      this.loading = true;

      const guid = this.$route.params.computerGuid;
      const res = await api.computers.getComputerDetail(guid);
      const computerDetail = res.data.entityData;
      this.selectedComp = computerDetail;

      if (
        computerDetail &&
        computerDetail.severityReport &&
        computerDetail.severityReport.length
      ) {
        computerDetail.severityReport.forEach((item) => {
          this.severityDistribution.series[0].data.push({
            name: `Severity ${item.key}`,
            value: item.value,
          });
        });
      }

      if (
        computerDetail &&
        computerDetail.severityReport &&
        computerDetail.severityReport.length
      ) {
        computerDetail.hashReport.forEach((item) => {
          this.maliciousHashes.series[0].data.push({
            name: item.key,
            value: item.value,
          });
        });
      }

      if (
        !this.maliciousHashes.series[0].data.find((i) => i.name == "Malicious")
      ) {
        this.maliciousHashes.series[0].data.push({
          name: "Malicious",
          value: 0,
          itemStyle: { color: "#d15656" },
        });
      }

      if (
        !this.maliciousHashes.series[0].data.find((i) => i.name == "Suspicious")
      ) {
        this.maliciousHashes.series[0].data.push({
          name: "Suspicious",
          value: 0,
          itemStyle: { color: "#f2ae11" },
        });
      }

      this.loading = false;

      const userRes = await api.computers.getComputerUserList(
        this.$route.params.computerGuid
      );
      if (userRes.status != 200) {
        let msg = userRes.data.message;
        msg += "<br>";
        msg += userRes.data.errors.join("<br>");
        Swal.fire("Error", msg, "error");
      } else {
        this.users = userRes.data.entityData;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ag-computer {
  h3 {
    color: #5e5e5e;
  }
  h6 {
    color: #9f9f9f;
  }
  .graphs {
    margin-top: -60px;
  }
}
</style>
